var GtxMatchesCounter = (function () {

    const {events: menuCountersManagerEvents} = require('./gtx-menu-counters-worker-manager')

    const menuMatchesCounterClass = "menu-matches-counter";
    const counterElements = document.getElementsByClassName(menuMatchesCounterClass);

    const loadingHandler = ev  => {
        if(ev.detail?.isLoading) {
            addIsLoading()
        }else{
            removeIsLoading()
        }
    }

    const addIsLoading = () => {
        for (let elem of counterElements) {
            elem.classList.add("is-loading");
        }
    };

    const removeIsLoading = () => {
        for (let elem of counterElements) {
            elem.classList.remove("is-loading");
        }

    };

    const updateMatchesCountDom = ({formattedValue, value}) => {
        for (let elem of counterElements) {
            if (value === 0) {
                elem.classList.add("gx-is-hidden");
            } else {
                elem.classList.remove("gx-is-hidden");

                const valueElems = elem.getElementsByClassName(`${menuMatchesCounterClass}__value`);

                for (let valueElem of valueElems) {
                    valueElem.innerHTML = formattedValue;
                }
            }
        }
    };

    const setMatchesCount = (value) => {
        if (value === null || value === undefined || !value.toString) return;

        let valueString = "";
        if (value === 0) {
            valueString = "";
        } else if (value > 99) {
            valueString = "99+";
        } else {
            valueString = value.toString();
        }

        updateMatchesCountDom({ formattedValue: valueString, value });
    };

    const handleCountersUpdate = ev => {
        setMatchesCount(ev.detail.newMatches || 0)
    }

    const initialize = () => {
        for (let elem of counterElements) {
            elem.classList.remove("gx-is-hidden");
        }

        window.addEventListener(menuCountersManagerEvents.LOADING_COUNTERS, loadingHandler)
        window.addEventListener(menuCountersManagerEvents.UPDATE_COUNTERS, handleCountersUpdate)

    };

    return {
        initialize,
    };
})();

module.exports = GtxMatchesCounter;
